import { render, staticRenderFns } from "./GalleryCreate.vue?vue&type=template&id=87b7585e&"
import script from "./GalleryCreate.vue?vue&type=script&lang=js&"
export * from "./GalleryCreate.vue?vue&type=script&lang=js&"
import style0 from "./GalleryCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports